<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a rosa chá</h1>
      <p>
        Com mais de 20 anos, a Rosa Chá leva para as lojas o que há de mais fresh na moda. Autêntica, global, cool e repleta de atitude, as coleções da marca são compostas por roupas e acessórios para todas as ocasiões – do dia a dia às festas – criadas com tecidos e matérias-primas sofisticadas. Bordados trabalhados, peças de couros e moda praia compõem o DNA da Rosa Chá, que dá vida ao seu lifestyle contemporâneo com um time descolado de embaixadoras.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>